import { render, staticRenderFns } from "./ComeBackToAdmin.vue?vue&type=template&id=6a7bb5f6&"
import script from "./ComeBackToAdmin.vue?vue&type=script&lang=js&"
export * from "./ComeBackToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ComeBackToAdmin.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports